import styled, {
  ThemeProvider as StyledComponentsThemeProvider,
  createGlobalStyle
} from "styled-components"
import { normalize } from "polished"
import theme from "./theme"
import Div100vh from "react-div-100vh"

const GlobalStyle = createGlobalStyle`
  ${normalize()}

  body {
    color: ${theme.palette.defaultFG};
    background-color: ${theme.palette.defaultBG};
    display: flex;
    flex-direction: column;
    fontSize: 16px;
    fontFamily: AzoSans-Regular;
    touch-action: pan-x pan-y;
  }

  #root {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  * {
    box-sizing: border-box;
  }

  a {
    text-decoration: none;    
    &:visited, &:active, &:link {
      color: inherit;
    }
  }

  *::-webkit-scrollbar {
    width: 5px;
    height: 10px;
  }
  *::-webkit-scrollbar-track {
    background-color: rgb(235, 235, 235);
    border-radius: 0px;
  }
  *::-webkit-scrollbar-thumb {
    height: 92px;
    background-color: #c5c5c5 ;
    border-radius: 0px;
  }
`

const Container = styled(Div100vh)`
  width: 100vw;
`

const ApplicationThemeProvider = ({ children }) => (
  <StyledComponentsThemeProvider theme={theme}>
    <GlobalStyle />
    <Container>{children}</Container>
  </StyledComponentsThemeProvider>
)

export default ApplicationThemeProvider
